"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f122 = void 0;
exports.f122 = {
    "za": [
        "Latn",
        "Hani",
        "Hans"
    ],
    "zaa": [
        "Latn"
    ],
    "zab": [
        "Latn"
    ],
    "zac": [
        "Latn"
    ],
    "zad": [
        "Latn"
    ],
    "zae": [
        "Latn"
    ],
    "zaf": [
        "Latn"
    ],
    "zag": [
        "Latn",
        "Arab",
        "Zzzz"
    ],
    "zah": [
        "Latn"
    ],
    "zaj": [
        "Latn"
    ],
    "zak": [
        "Latn"
    ],
    "zal": [
        "Zyyy"
    ],
    "zam": [
        "Latn"
    ],
    "zao": [
        "Latn"
    ],
    "zap": [
        "Latn"
    ],
    "zaq": [
        "Latn"
    ],
    "zar": [
        "Latn"
    ],
    "zas": [
        "Latn"
    ],
    "zat": [
        "Latn"
    ],
    "zau": [
        "Tibt"
    ],
    "zav": [
        "Latn"
    ],
    "zaw": [
        "Latn"
    ],
    "zax": [
        "Latn"
    ],
    "zay": [
        "Latn",
        "Ethi"
    ],
    "zaz": [
        "Latn"
    ],
    "zba": [
        "Arab"
    ],
    "zbc": [
        "Latn"
    ],
    "zbe": [
        "Latn"
    ],
    "zbl": [
        "Blis"
    ],
    "zbt": [
        "Latn"
    ],
    "zbu": [
        "Latn"
    ],
    "zbw": [
        "Latn"
    ],
    "zca": [
        "Latn"
    ],
    "zch": [
        "Hani"
    ],
    "zdj": [
        "Arab",
        "Latn"
    ],
    "zea": [
        "Latn"
    ],
    "zeg": [
        "Latn"
    ],
    "zeh": [
        "Hani"
    ],
    "zen": [
        "Tfng",
        "Arab"
    ],
    "zga": [
        "Latn"
    ],
    "zgb": [
        "Hani"
    ],
    "zgh": [
        "Tfng"
    ],
    "zgm": [
        "Hani"
    ],
    "zgn": [
        "Hani"
    ],
    "zgr": [
        "Latn"
    ],
    "zh": [
        "Hant",
        "Bopo",
        "Brai",
        "Hans",
        "Hanb",
        "Latn",
        "Phag"
    ],
    "zhb": [
        "Zyyy"
    ],
    "zhd": [
        "Hani",
        "Latn"
    ],
    "zhi": [
        "Latn"
    ],
    "zhn": [
        "Hani",
        "Latn"
    ],
    "zhw": [
        "Latn"
    ],
    "zhx": [
        "Nshu"
    ],
    "zia": [
        "Latn"
    ],
    "zib": [
        "Zxxx"
    ],
    "zik": [
        "Latn"
    ],
    "zil": [
        "Latn"
    ],
    "zim": [
        "Latn"
    ],
    "zin": [
        "Latn"
    ],
    "ziw": [
        "Latn"
    ],
    "ziz": [
        "Latn"
    ],
    "zka": [
        "Latn"
    ],
    "zkb": [
        "Cyrl"
    ],
    "zkd": [
        "Latn"
    ],
    "zkg": [
        "Zyyy"
    ],
    "zkh": [
        "Zyyy"
    ],
    "zkk": [
        "Zyyy"
    ],
    "zkn": [
        "Zyyy"
    ],
    "zko": [
        "Cyrl"
    ],
    "zkp": [
        "Latn"
    ],
    "zkr": [
        "Zyyy"
    ],
    "zkt": [
        "Kitl",
        "Kits"
    ],
    "zku": [
        "Latn"
    ],
    "zkv": [
        "Zyyy"
    ],
    "zkz": [
        "Cyrl"
    ],
    "zla": [
        "Latn"
    ],
    "zlj": [
        "Hani",
        "Latn"
    ],
    "zlm": [
        "Latn",
        "Arab"
    ],
    "zln": [
        "Hani"
    ],
    "zlq": [
        "Hani"
    ],
    "zma": [
        "Latn"
    ],
    "zmb": [
        "Latn"
    ],
    "zmc": [
        "Latn"
    ],
    "zmd": [
        "Latn"
    ],
    "zme": [
        "Latn"
    ],
    "zmf": [
        "Latn"
    ],
    "zmg": [
        "Latn"
    ],
    "zmh": [
        "Latn"
    ],
    "zmi": [
        "Latn"
    ],
    "zmj": [
        "Latn"
    ],
    "zmk": [
        "Latn"
    ],
    "zml": [
        "Latn"
    ],
    "zmm": [
        "Latn"
    ],
    "zmn": [
        "Latn"
    ],
    "zmo": [
        "Latn"
    ],
    "zmp": [
        "Latn"
    ],
    "zmq": [
        "Latn"
    ],
    "zmr": [
        "Latn"
    ],
    "zms": [
        "Latn"
    ],
    "zmt": [
        "Latn"
    ],
    "zmu": [
        "Latn"
    ],
    "zmv": [
        "Latn"
    ],
    "zmw": [
        "Latn"
    ],
    "zmx": [
        "Latn"
    ],
    "zmy": [
        "Latn"
    ],
    "zmz": [
        "Latn"
    ],
    "zna": [
        "Latn"
    ],
    "zne": [
        "Latn",
        "Arab"
    ],
    "zng": [
        "Latn"
    ],
    "znk": [
        "Latn"
    ],
    "zns": [
        "Latn"
    ],
    "zoc": [
        "Latn"
    ],
    "zoh": [
        "Latn"
    ],
    "zom": [
        "Latn"
    ],
    "zoo": [
        "Latn"
    ],
    "zoq": [
        "Latn"
    ],
    "zor": [
        "Latn"
    ],
    "zos": [
        "Latn"
    ],
    "zpa": [
        "Latn"
    ],
    "zpb": [
        "Latn"
    ],
    "zpc": [
        "Latn"
    ],
    "zpd": [
        "Latn"
    ],
    "zpe": [
        "Latn"
    ],
    "zpf": [
        "Latn"
    ],
    "zpg": [
        "Latn"
    ],
    "zph": [
        "Latn"
    ],
    "zpi": [
        "Latn"
    ],
    "zpj": [
        "Latn"
    ],
    "zpk": [
        "Latn"
    ],
    "zpl": [
        "Latn"
    ],
    "zpm": [
        "Latn"
    ],
    "zpn": [
        "Latn"
    ],
    "zpo": [
        "Latn"
    ],
    "zpp": [
        "Latn"
    ],
    "zpq": [
        "Latn"
    ],
    "zpr": [
        "Latn"
    ],
    "zps": [
        "Latn"
    ],
    "zpt": [
        "Latn"
    ],
    "zpu": [
        "Latn"
    ],
    "zpv": [
        "Latn"
    ],
    "zpw": [
        "Latn"
    ],
    "zpx": [
        "Latn"
    ],
    "zpy": [
        "Latn"
    ],
    "zpz": [
        "Latn"
    ],
    "zqe": [
        "Hani",
        "Latn"
    ],
    "zra": [
        "Zyyy"
    ],
    "zrg": [
        "Orya",
        "Telu"
    ],
    "zrn": [
        "Latn"
    ],
    "zro": [
        "Latn"
    ],
    "zrp": [
        "Hebr"
    ],
    "zrs": [
        "Latn"
    ],
    "zsa": [
        "Latn"
    ],
    "zsk": [
        "Zyyy"
    ],
    "zsl": [
        "Zxxx"
    ],
    "zsr": [
        "Latn"
    ],
    "zsu": [
        "Latn"
    ],
    "zte": [
        "Latn"
    ],
    "ztg": [
        "Latn"
    ],
    "ztl": [
        "Latn"
    ],
    "ztm": [
        "Latn"
    ],
    "ztn": [
        "Latn"
    ],
    "ztp": [
        "Latn"
    ],
    "ztq": [
        "Latn"
    ],
    "zts": [
        "Latn"
    ],
    "ztt": [
        "Latn"
    ],
    "ztu": [
        "Latn"
    ],
    "ztx": [
        "Latn"
    ],
    "zty": [
        "Latn"
    ],
    "zu": [
        "Latn",
        "Brai"
    ],
    "zua": [
        "Latn"
    ],
    "zuh": [
        "Latn"
    ],
    "zum": [
        "Zyyy"
    ],
    "zun": [
        "Latn"
    ],
    "zuy": [
        "Latn"
    ],
    "zwa": [
        "Zyyy"
    ],
    "zxx": [
        "Zyyy"
    ],
    "zyg": [
        "Hani"
    ],
    "zyj": [
        "Latn",
        "Hani"
    ],
    "zyn": [
        "Hani"
    ],
    "zyp": [
        "Latn"
    ],
    "zza": [
        "Latn",
        "Arab"
    ],
    "zzj": [
        "Hani"
    ]
};
